// 智能文档管理页面
<template>
  <div class="flex">
    <!-- 路由导航 -->
    <div class="left-menu">
      <div class="title">帮助中心</div>
      <el-menu
        :default-active="activeId"
        active-text-color="#ec1c1c"
        @open="handleOpen"
      >
        <el-menu-item v-for="meun of docMenus" :key="meun.id" :index="meun.id" @click="activeId = meun.id">
          <i
            style="color:#a4bbe7;width:18px;height:18px"
          ></i>
          <span slot="title">{{ meun.name }}</span>
        </el-menu-item>
      </el-menu>
    </div>
    <!-- 详情页面 -->
    <div class="view">
      <ul class="content_box">
        <component :is="currentComponent"></component>
      </ul>
    </div>
  </div>
</template>

<script>
// components
import localFileSign from './helpCenterCom/1_localFileSign.vue';
import tempSign from './helpCenterCom/2_tempSign.vue';
import permsToMenber from './helpCenterCom/3_permsToMenber.vue';
import apprFile from './helpCenterCom/4_apprFile.vue';
import signToMenber from './helpCenterCom/5_signToMenber.vue';
import menberUse from './helpCenterCom/6_menberUse.vue';
import expireRemind from './helpCenterCom/29_expireRemind.vue';
import addApprFlow from './helpCenterCom/10_addApprFlow.vue';
import viewContractFile from './helpCenterCom/31_viewContractFile.vue';

  // 数据
  export default {
    components:{
      localFileSign,
      permsToMenber,
      apprFile,
      menberUse,
      tempSign,
      signToMenber,
      expireRemind,
      addApprFlow,
      viewContractFile,
    },
    data() {
      return {
        currentComponent:'localFileSign',
        activeId: '1',
        docMenus: [
          {
            id: '1',
            name: '如何使用本地文件发起签约',
            comName:'localFileSign',
          },
          {
            id: '2',
            name: '如何使用模板发起签约',
            comName:'tempSign',
          },
          {
            id: '3',
            name: '如何分配权限给成员',
            comName:'permsToMenber',
          },
          {id: '4',name: '如何创建文件发起审批',comName:'apprFile',},
          {id: '5', name: '如何将印章授权给成员使用',comName:'signToMenber',},
          {id: '6',name: '如何为印章关联审批',comName:'menberUse',},
          { name: '如何设置到期提醒', id: '29',comName:'expireRemind' },
          { name: '如何新增电子合同发起审批流程', id: '10',comName:'addApprFlow' },
          { name: '如何查看企业成员电子合同文件', id: '31',comName:'viewContractFile' },
        ],
      };
    },
    mounted() {
      this.activeId = this.$route.query.text || '1';
    },
    // data end
    methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      }
    },
    watch:{
      activeId(val){
        this.currentComponent = this.docMenus.find(item => item.id === val).comName;
      }
    }
  };
</script>

<style scoped lang="less">
  .left-menu {
    // width: 13vw;
    width: 230px;
    /*height: 85vh;*/
    /*margin-right: 10px;*/
    background: #fff;
    overflow: auto;
    color: #333;
    flex-shrink: 0;
    .title {
      font-size: 22px;
      font-weight: bold;
      padding: 10px 0 0 20px;
    }
  }
  .flex {
    display: flex;
    justify-content: center;
    min-height: 80vh;
  }
  .view {
    min-height: 80vh;
    background-color: #ffffff;
    width: calc(1366px - 230px - 30px);
    margin-left: 10px;
    .content_box {
      .list_once {
        font-size: 14px;
        padding: 10px;
        .p {
          font-size: 16px;
          font-weight: bold;
        }
        .text {
          margin: 10px 0;
        }
        .img {
          max-width: 100%;
        }
      }
    }
  }
  .dis-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>


// WEBPACK FOOTER //
// pages/dingtalkUse/product_notice.vue